import { getSnapshots } from './api';
import { snapshotsKeys } from './keys';

export const getSnapshotsQueryOptions = () => ({
  queryKey: snapshotsKeys.list(),
  queryFn: () => getSnapshots(),
});
